/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';
let exports = {};

// ====================== 虚拟零售商 ======================

exports.getVirtualRetailerList = function (data, callback) {// 获取 - 虚拟零售商列表
    api.post('/retailer/virtual/retailer/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.saveVirtualRetailer = function (data, callback) {// 新增虚拟商户（零售商）
    api.post('/retailer/virtual/retailer/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateVirtualRetailerForDisabled = function (data, callback) {// 虚拟商户（零售商）启、禁用
    api.post('/retailer/virtual/retailer/update/disabled/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getVirtualRetailerComInfo = function (data, callback) {// 虚拟商户（零售商）总公司信息
    api.post('/retailer/virtual/retailer/com/info')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getVirtualRetailerComList = function (data, callback) {// 虚拟商户-公司列表
    api.post('/retailer/virtual/retailer/com/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.saveVirtualRetailerCom = function (data, callback) {// 虚拟商户-新增子公司
    api.post('/retailer/virtual/retailer/com/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateVirtualRetailerCom = function (data, callback) {// 虚拟商户-更新子公司
    api.post('/retailer/virtual/retailer/com/update/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.moveVirtaulRetailerComSeq = function (data, callback) {// 虚拟商户-移动子公司
    api.post('/retailer/virtual/retailer/com/seq/move/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.deleteVirtualRetailerCom = function (data, callback) {// 虚拟商户-删除子公司
    api.post('/retailer/virtual/retailer/com/delete/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.saveVirtualRetailerComBatch = function (data, callback) {// 虚拟商户-批量导入机构
    api.post('/retailer/virtual/retailer/com/batch/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.specifyRetailerChildComAdmin = function (data, callback) {// 虚拟商户-批量导入机构
    api.post('/retailer/virtual/child/com/admin/specify/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getRetailerChildComAdmin = function (params, callback) {// 虚拟商户-批量导入机构
    api.get('/retailer/virtual/child/com/admin/get')
    .params(params)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/virtual.js
// module id = 71
// module chunks = 1